module.exports = __webpack_public_path__ + "static/PP9s-4249e47976f2a91bdc61e4c16caa21db.jpg";